
import { useState, FormEvent } from 'react';

export interface ClientInfo {
  clientName: string;
  clientEmail: string;
  clientPhone: string;
  clientAddress: string;
  eventDate: string;
  eventType: string;
  eventVenue: string;
  notes: string;
}

interface ClientFormProps {
  clientInfo: ClientInfo;
  onChange: (info: ClientInfo) => void;
}

export default function ClientForm({ clientInfo, onChange }: ClientFormProps) {
  const handleChange = (field: keyof ClientInfo, value: string) => {
    onChange({ ...clientInfo, [field]: value });
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-stone-500 mb-1.5">Client Name *</label>
          <input
            type="text"
            value={clientInfo.clientName}
            onChange={(e) => handleChange('clientName', e.target.value)}
            placeholder="Full name or company"
            className="w-full px-3.5 py-2.5 border border-stone-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-amber-400 bg-white"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-stone-500 mb-1.5">Email *</label>
          <input
            type="email"
            value={clientInfo.clientEmail}
            onChange={(e) => handleChange('clientEmail', e.target.value)}
            placeholder="client@email.com"
            className="w-full px-3.5 py-2.5 border border-stone-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-amber-400 bg-white"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-stone-500 mb-1.5">Phone</label>
          <input
            type="tel"
            value={clientInfo.clientPhone}
            onChange={(e) => handleChange('clientPhone', e.target.value)}
            placeholder="+61 4XX XXX XXX"
            className="w-full px-3.5 py-2.5 border border-stone-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-amber-400 bg-white"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-stone-500 mb-1.5">Event Date *</label>
          <input
            type="date"
            value={clientInfo.eventDate}
            onChange={(e) => handleChange('eventDate', e.target.value)}
            className="w-full px-3.5 py-2.5 border border-stone-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-amber-400 bg-white"
          />
        </div>
      </div>

      <div>
        <label className="block text-xs font-medium text-stone-500 mb-1.5">Client Address</label>
        <input
          type="text"
          value={clientInfo.clientAddress}
          onChange={(e) => handleChange('clientAddress', e.target.value)}
          placeholder="Street address, suburb, VIC"
          className="w-full px-3.5 py-2.5 border border-stone-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-amber-400 bg-white"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-stone-500 mb-1.5">Event Type</label>
          <select
            value={clientInfo.eventType}
            onChange={(e) => handleChange('eventType', e.target.value)}
            className="w-full px-3.5 py-2.5 border border-stone-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-amber-400 bg-white cursor-pointer"
          >
            <option value="">Select type...</option>
            <option value="Wedding">Wedding</option>
            <option value="Corporate Event">Corporate Event</option>
            <option value="Private Party">Private Party</option>
            <option value="Birthday">Birthday</option>
            <option value="Engagement">Engagement</option>
            <option value="Gala Dinner">Gala Dinner</option>
            <option value="Festival">Festival</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-stone-500 mb-1.5">Event Venue</label>
          <input
            type="text"
            value={clientInfo.eventVenue}
            onChange={(e) => handleChange('eventVenue', e.target.value)}
            placeholder="Venue name, Melbourne"
            className="w-full px-3.5 py-2.5 border border-stone-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-amber-400 bg-white"
          />
        </div>
      </div>

      <div>
        <label className="block text-xs font-medium text-stone-500 mb-1.5">Additional Notes</label>
        <textarea
          value={clientInfo.notes}
          onChange={(e) => {
            if (e.target.value.length <= 500) handleChange('notes', e.target.value);
          }}
          placeholder="Special requirements, delivery instructions..."
          rows={3}
          maxLength={500}
          className="w-full px-3.5 py-2.5 border border-stone-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-amber-400 bg-white resize-none"
        />
        <p className="text-[10px] text-stone-400 text-right mt-0.5">{clientInfo.notes.length}/500</p>
      </div>
    </div>
  );
}
